import { render } from "./LkReportView.vue?vue&type=template&id=5b2b127a"
import script from "./LkReportView.vue?vue&type=script&lang=js"
export * from "./LkReportView.vue?vue&type=script&lang=js"

import "./LkReportView.vue?vue&type=style&index=0&id=5b2b127a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__